import React, { useContext, useEffect } from 'react'
import { context } from './index'

export function useEvents (evntName, callback) {
  const eventsManager = useContext(context)
  useEffect(() => {
    let unsubscribeEvent
    if (callback) {
      unsubscribeEvent = eventsManager.addEventListener(evntName, callback)
    }
    
    return () => {
      unsubscribeEvent && unsubscribeEvent()
    }
  },[evntName, callback])

  return eventPayload => eventsManager.dispatch(evntName, eventPayload)
}